import styled from "styled-components";
import { SummaryLabel, SummaryData } from "../../../../../../CommonComponents/commonStyles";

export const SummaryContainer = styled.div`
  display: flex;
  margin: 30px 0 45px;
  .ant-divider:last-child {
    display: none;
  }
  @media only screen and (max-width: 991px) {
    flex-direction: column;
    margin: 20px 0 30px;
  }
`;

export const Loader = styled.img`
  width: 30px;
  height: 30px;
  ${({ alignLoader }) => alignLoader && `  
    position: absolute;
    bottom: 0;
    @media only screen and (max-width: 767px) {
      position: relative;
    }
  }
`}
`

export const SummaryContent = styled.div`
  padding-right: 50px;
  margin-right: 50px;
  position: relative;
  display: inline-block;
  border-right: 1px solid #d4d4d4;
  &:last-child {
    border-right: none;
  } 
  @media only screen and (max-width: 991px) {
    display: ${props => props.accountWrapper ? 'inline-block' : 'flex'};
    justify-content: space-between;
    margin-right: 0;
    padding-right: 0;
    padding-bottom: 10px;
    margin-bottom: 10px;
    align-items: center;
    border-right: none;
    border-bottom: ${props => props.noBorder ? 'none' : '1px solid #d4d4d4'};
    &:last-child {
      margin-bottom: 0;
    }
  }
  ${SummaryLabel}{
    letter-spacing: normal;
    padding-bottom: 0;
    @media only screen and (max-width: 767px) {
      font-size: ${props => props.theme.fontSize.secondary};      
    }
  }
  ${SummaryData}{
    text-align: ${props => props.accountWrapper ? 'left' : 'right'} !important;
    letter-spacing: normal;
    @media only screen and (max-width: 767px) {
      font-size: ${props => props.theme.fontSize.h5};
    }
  }
`;